app.service('fusionRelevanceRatingService', [
  '$ngConfirm', 'HttpAuth', 'apiHelper', 'portalHelper', 'CONSTANTS',
  function ($ngConfirm, HttpAuth, apiHelper, portalHelper, CONSTANTS) {
    /**
     * Sets up the common scope variables needed by edit_relevance_rating.html dialog.
     * Call this in $onInit of any component that uses fusion relevance ratings.
     */
    this.setupScope = function ($scope) {
      $scope.payer_relevance_rating_choices = [
        CONSTANTS.payerRelevanceRatings.NO_RATING,
        CONSTANTS.payerRelevanceRatings.LOW_RELEVANCE,
        CONSTANTS.payerRelevanceRatings.ACCEPTABLE_RELEVANCE,
        CONSTANTS.payerRelevanceRatings.HIGH_RELEVANCE
      ];

      $scope.check_save_button_state = function () {
        if ($scope.initial_rating === $scope.selected_response_to_edit_relevance_rating.relevance_rating.rating) {
          $scope.edit_relevance_popup.buttons.OK.setDisabled(true);
          return;
        }
        $scope.edit_relevance_popup.buttons.OK.setDisabled(false);
      };
    };

    /**
     * Opens the relevance rating edit dialog for a fusion payer or an IDI stakeholder.
     *
     * @param {Object} $scope - The component scope
     * @param {Object} options
     * @param {string} options.payerName - Full name of the payer / stakeholder
     * @param {number} [options.fusionAssignmentId] - The fusion assignment ID
     * @param {number} [options.idiStakeholderId] - The IDI stakeholder ID (instead of fusionAssignmentId)
     * @param {Object|null} options.currentRating - Existing relevance_rating object or null
     * @param {Function} options.onSuccess - Callback after successful save, receives API response data
     */
    this.openEditDialog = function ($scope, { payerName, fusionAssignmentId, idiStakeholderId, currentRating, onSuccess }) {
      const association = idiStakeholderId
        ? { idi_stakeholder: idiStakeholderId }
        : { fusion_assignment: fusionAssignmentId };
      $scope.relevance_rating_entity_label = idiStakeholderId ? 'IDI project' : 'survey';
      $scope.selected_response_to_edit_relevance_rating = {
        payer: {
          first_name: (payerName || '').split(' ')[0],
          last_name: (payerName || '').split(' ').slice(1).join(' ')
        },
        relevance_rating: currentRating
          ? angular.copy(currentRating)
          : { rating: null }
      };

      $scope.selected_response_to_edit_relevance_rating.relevance_rating =
        portalHelper.addChangeHistoryLabel($scope.payer_relevance_rating_choices, $scope.selected_response_to_edit_relevance_rating.relevance_rating);

      $scope.initial_rating = $scope.selected_response_to_edit_relevance_rating.relevance_rating.rating;

      const API_URL = apiHelper.getApiUrl();

      $scope.edit_relevance_popup = $ngConfirm({
        title: 'Set Relevance Rating',
        contentUrl: portalHelper.getUrlRev('../html_templates/dialogs/edit_relevance_rating.52c2ce1b.html'),
        type: 'blue',
        closeIcon: true,
        columnClass: 'medium',
        scope: $scope,
        buttons: {
          OK: {
            text: 'Save Relevance Rating',
            btnClass: 'mat ui primary button',
            action: function (scope, button) {
              button.setText('Saving...');
              button.setDisabled(true);
              let url, method, data;

              if (scope.selected_response_to_edit_relevance_rating.relevance_rating.id) {
                url = API_URL + '/api/admin/survey/rating/submit/' + scope.selected_response_to_edit_relevance_rating.relevance_rating.id + '.json';
                method = HttpAuth.put;
                data = {
                  rating: scope.selected_response_to_edit_relevance_rating.relevance_rating.rating,
                  id: scope.selected_response_to_edit_relevance_rating.relevance_rating.id,
                  ...association
                };
              } else {
                url = API_URL + '/api/admin/survey/rating/submit.json';
                method = HttpAuth.post;
                data = {
                  rating: scope.selected_response_to_edit_relevance_rating.relevance_rating.rating,
                  ...association
                };
              }

              method(url, data)
                .then(function (result) {
                  portalHelper.showToast(CONSTANTS.typeOfToasts.SUCCESS, 'Rating updated successfully');
                  if (onSuccess) onSuccess(result.data);
                })
                .catch(function (error) {
                  portalHelper.showErrorCommon(error);
                })
                .finally(function () {
                  button.setText('Save Relevance Rating');
                  button.setDisabled(false);
                  scope.edit_relevance_popup.close();
                });

              return false;
            }
          }
        }
      });

      $scope.edit_relevance_popup.buttons.OK.setDisabled(true);
    };
  }
]);
